import { DIFFICULTY_LEVELS, QUESTION_TYPES } from './questionTypes';

// Banco ampliado de preguntas de verdadero/falso por regiones
export const trueFalseQuestions = [
  // Cabeza y cara
  {
    id: 'tf_cabeza_001',
    question: 'El hueso frontal forma parte de la bóveda craneal.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_002',
    question: 'El hueso esfenoides participa en la formación de la base del cráneo.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_003',
    question: 'Los senos paranasales frontal y maxilar se comunican con la cavidad nasal.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_004',
    question: 'El nervio trigémino es exclusivamente motor para los músculos de la masticación.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_005',
    question: 'El nervio facial (VII) es el principal nervio motor de la expresión facial.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_006',
    question: 'La arteria carótida interna irriga directamente la piel de la cara.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_007',
    question: 'La fosa craneal posterior aloja principalmente el cerebelo y el tronco encefálico.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_008',
    question: 'El hueso temporal contiene el oído medio y el oído interno.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_009',
    question: 'La arteria meníngea media es rama de la arteria carótida interna.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cabeza_010',
    question: 'El seno cavernoso es un seno venoso dural localizado a ambos lados de la silla turca.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cabeza',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },

  // Cuello
  {
    id: 'tf_cuello_001',
    question: 'La tráquea se encuentra por delante del esófago en el cuello.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_002',
    question: 'La vena yugular interna se localiza lateral a la arteria carótida común dentro de la vaina carotídea.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_003',
    question: 'La glándula tiroides se sitúa por encima del cartílago tiroides.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_004',
    question: 'El nervio vago desciende dentro de la vaina carotídea.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_005',
    question: 'El músculo esternocleidomastoideo delimita los triángulos anterior y posterior del cuello.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_006',
    question: 'La arteria carótida externa no emite ramas en el cuello.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_007',
    question: 'El nervio accesorio (XI) inerva al músculo trapecio y al esternocleidomastoideo.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_008',
    question: 'La cadena simpática cervical se encuentra por delante de la vaina carotídea.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_009',
    question: 'Las glándulas paratiroides suelen localizarse en la cara posterior de la tiroides.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_cuello_010',
    question: 'La arteria vertebral pasa a través de los forámenes transversos de las vértebras cervicales.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'cuello',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },

  // Tórax
  {
    id: 'tf_torax_001',
    question: 'El ventrículo derecho bombea sangre hacia la aorta.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_002',
    question: 'El corazón se encuentra dentro del mediastino medio.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_003',
    question: 'La vena cava superior desemboca en la aurícula izquierda.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_004',
    question: 'La válvula tricúspide se ubica entre la aurícula izquierda y el ventrículo izquierdo.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_005',
    question: 'La arteria pulmonar transporta sangre pobre en oxígeno desde el ventrículo derecho hacia los pulmones.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_006',
    question: 'El nervio frénico desciende por delante del hilio pulmonar.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_007',
    question: 'La pleura parietal tapiza directamente la superficie del pulmón.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_008',
    question: 'El conducto torácico drena la linfa de la mayor parte del cuerpo en la unión de la vena yugular interna izquierda y la subclavia izquierda.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_009',
    question: 'El nervio vago proporciona fibras parasimpáticas a los pulmones y al corazón.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_torax_010',
    question: 'La aorta ascendente se continúa directamente como aorta abdominal sin porción torácica.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'torax',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },

  // Abdomen
  {
    id: 'tf_abdomen_001',
    question: 'El hígado se localiza exclusivamente en el cuadrante inferior izquierdo.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_002',
    question: 'El páncreas se encuentra retroperitoneal en la mayor parte de su extensión.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_003',
    question: 'El estómago recibe irrigación únicamente de la arteria gástrica izquierda.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_004',
    question: 'El colon sigmoide se localiza en la fosa iliaca derecha.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_005',
    question: 'El mesenterio del intestino delgado contiene vasos, nervios y linfáticos para el yeyuno e íleon.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_006',
    question: 'La vena porta hepática se forma por la unión de la vena mesentérica superior y la vena esplénica.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_007',
    question: 'Los riñones se sitúan dentro de la cavidad peritoneal completamente cubiertos por peritoneo visceral.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_008',
    question: 'La arteria mesentérica superior irriga principalmente el intestino medio.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_009',
    question: 'El bazo se encuentra normalmente en el hipocondrio derecho.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_abdomen_010',
    question: 'El conducto colédoco desemboca junto al conducto pancreático principal en la segunda porción del duodeno.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'abdomen',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },

  // Espalda
  {
    id: 'tf_espalda_001',
    question: 'La médula espinal termina habitualmente a nivel de la vértebra L2 en el adulto.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_002',
    question: 'El ligamento amarillo conecta las láminas adyacentes de las vértebras.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_003',
    question: 'La curvatura torácica de la columna vertebral es una curvatura secundaria (de desarrollo posnatal).',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_004',
    question: 'El músculo trapecio se inerva exclusivamente por ramas de los nervios espinales dorsales.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_005',
    question: 'El espacio epidural contiene grasa y plexos venosos vertebrales internos.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_006',
    question: 'Las raíces nerviosas lumbares descienden dentro del saco dural formando la cola de caballo.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_007',
    question: 'Los procesos espinosos torácicos se orientan casi horizontalmente.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_008',
    question: 'El músculo dorsal ancho participa en la aducción y rotación medial del brazo.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_009',
    question: 'Los nervios espinales salen del conducto vertebral únicamente por arriba de las vértebras correspondientes.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_espalda_010',
    question: 'La arteria espinal anterior irriga la porción anterior de la médula espinal.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'espalda',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },

  // Pelvis
  {
    id: 'tf_pelvis_001',
    question: 'La vejiga urinaria se encuentra por detrás del recto en el varón.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_002',
    question: 'El útero normalmente está en anteversión y anteflexión sobre la vagina.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_003',
    question: 'El plexo sacro se forma por la unión de las raíces lumbares superiores y torácicas inferiores.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_004',
    question: 'El músculo elevador del ano es parte principal del diafragma pélvico.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_005',
    question: 'La arteria ilíaca interna es la principal fuente de irrigación pélvica.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_006',
    question: 'El recto está totalmente cubierto por peritoneo en toda su extensión.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_007',
    question: 'El nervio pudendo abandona la pelvis a través del agujero ciático mayor.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_008',
    question: 'En la mujer, la uretra es mucho más larga que en el varón.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_009',
    question: 'El foramen obturador está limitado por el pubis y el isquion.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pelvis_010',
    question: 'La arteria uterina se cruza por debajo del uréter cerca del cuello uterino.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pelvis',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },

  // Brazo
  {
    id: 'tf_brazo_001',
    question: 'El nervio radial inerva principalmente la musculatura extensora del miembro superior.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_002',
    question: 'El nervio musculocutáneo perfora el músculo coracobraquial.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_003',
    question: 'La vena cefálica corre en el surco deltopectoral y suele drenar en la vena axilar.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_004',
    question: 'El nervio mediano inerva todos los músculos intrínsecos de la mano.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_005',
    question: 'El tendón del bíceps braquial se inserta en la tuberosidad radial.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_006',
    question: 'La arteria braquial se divide en radial y ulnar a nivel del cuello humeral.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_007',
    question: 'El nervio ulnar pasa por detrás del epicóndilo medial del húmero.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_008',
    question: 'El manguito rotador está formado por supraespinoso, infraespinoso, redondo mayor y subescapular.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_009',
    question: 'El nervio axilar rodea el cuello quirúrgico del húmero junto a la arteria circunfleja humeral posterior.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_brazo_010',
    question: 'El músculo tríceps braquial es flexor del codo.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'brazo',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },

  // Pierna
  {
    id: 'tf_pierna_001',
    question: 'El nervio tibial se ubica en el compartimento anterior de la pierna.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_002',
    question: 'El nervio peroneo común rodea la cabeza del peroné y es vulnerable a lesiones en esta zona.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_003',
    question: 'El tendón de Aquiles corresponde a la inserción conjunta de gastrocnemio y sóleo.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_004',
    question: 'La arteria tibial anterior atraviesa la membrana interósea para llegar al compartimento anterior de la pierna.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_005',
    question: 'El nervio femoral inerva la mayor parte de los músculos extensores de la rodilla.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_006',
    question: 'La vena safena magna drena en la vena femoral a nivel del triángulo femoral.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_007',
    question: 'El ligamento cruzado anterior evita el desplazamiento posterior de la tibia respecto al fémur.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.GENERAL,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_008',
    question: 'Los meniscos medial y lateral son estructuras fibrocartilaginosas que aumentan la congruencia articular de la rodilla.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_009',
    question: 'La articulación talocrural permite principalmente movimientos de flexión dorsal y flexión plantar del pie.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 0,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.BASICO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  },
  {
    id: 'tf_pierna_010',
    question: 'La arteria dorsal del pie es continuación de la arteria tibial posterior.',
    options: ['Verdadero', 'Falso'],
    correctAnswer: 1,
    region: 'pierna',
    difficulty: DIFFICULTY_LEVELS.COMPLEJO,
    type: QUESTION_TYPES.VERDADERO_FALSO
  }
];
